import { render, staticRenderFns } from "./ArticleCategoryModal.vue?vue&type=template&id=5ae6c8a7&scoped=true"
import script from "./ArticleCategoryModal.vue?vue&type=script&lang=js"
export * from "./ArticleCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./ArticleCategoryModal.vue?vue&type=style&index=0&id=5ae6c8a7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae6c8a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae6c8a7')) {
      api.createRecord('5ae6c8a7', component.options)
    } else {
      api.reload('5ae6c8a7', component.options)
    }
    module.hot.accept("./ArticleCategoryModal.vue?vue&type=template&id=5ae6c8a7&scoped=true", function () {
      api.rerender('5ae6c8a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/CateManage/components/ArticleCategoryModal.vue"
export default component.exports